import { IFormProps } from 'framework/forms/common/IFormProps';
import { FormAutocompleteField } from 'framework/forms/FormAutocompleteField';
import { IOption } from 'framework/IOption';
import React from 'react';
import { useNonDeletedLocationSummaries } from '../useNonDeletedLocationSummaries';

export const FormSelectLocationField = <TModel extends unknown>({ name, label, ...rest }: IFormProps<TModel>) => {
	const [locations] = useNonDeletedLocationSummaries();

	if (locations === undefined) {
		return <div></div>;
	}

	return (
		<FormAutocompleteField<TModel, IOption<string>>
			{...rest}
			name={name}
			options={locations}
			label={label}
			style={{ width: '100%' }}
		/>
	);
};
